import { render, staticRenderFns } from "./TpmMonitor.vue?vue&type=template&id=3f80b01f&scoped=true"
import script from "./TpmMonitor.vue?vue&type=script&lang=js"
export * from "./TpmMonitor.vue?vue&type=script&lang=js"
import style0 from "./TpmMonitor.vue?vue&type=style&index=0&id=3f80b01f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f80b01f",
  null
  
)

export default component.exports